import { render } from "./DetailHistoryMappingForm.vue?vue&type=template&id=02858b9b&scoped=true"
import script from "./DetailHistoryMappingForm.vue?vue&type=script&lang=js"
export * from "./DetailHistoryMappingForm.vue?vue&type=script&lang=js"

import "./DetailHistoryMappingForm.vue?vue&type=style&index=0&id=02858b9b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-02858b9b"

export default script